// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__4HqYL","dragIcon":"Choice_dragIcon__1FluJ","left":"Choice_left__2YPOn","input":"Choice_input__W0ajp"};